export default __webpack_public_path__ + "media/plus/transfer-visual-mobile-e90439de.svg";